import {Component} from '@angular/core';
import {ICellEditorAngularComp, ICellRendererAngularComp} from 'ag-grid-angular/main';
import {forEach} from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-state-popover',
  templateUrl: './popover.component.html'
})
export class StatePopoverComponent implements ICellEditorAngularComp, ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  // demonstrates how you can do "inline" editing of a cell
  onChange($event) {
  }

  getValue() {
    return this.params.value;
  }

  getClass() {
    let className = 'btn-block btn btn-sm btn-raised btn-'
    if (this.params.data.fkcampaignVoucherStatus == 1) {
      return className += 'primary';
    } else if (this.params.data.fkcampaignVoucherStatus == 2) {
      return className += 'success';
    } else if (this.params.data.fkcampaignVoucherStatus == 3) {
      return className += 'danger';
    } else if (this.params.data.fkcampaignVoucherStatus == 4) {
      return className += 'success';
    } else if (this.params.data.fkcampaignVoucherStatus == 5) {
      return className += 'danger';
    } else if (this.params.data.fkcampaignVoucherStatus == 6) {
      return className += 'primary';
    }
  }

  refresh(params: any): boolean {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ag-grid-custom-components/state-popover/popover.components.ts